import type { Session } from "../../common/types/companyTypes";
import { authSessionRequest, parseAuthSession } from "./authSessionRequest";
import type { LoginSessionParams, VerifySmsLoginParams } from "./authSessionTypes";

export const loginSessionWithCookie = async (loginEndpoint: string, params: LoginSessionParams): Promise<Session> => {
   const session = await authSessionRequest(loginEndpoint, { includeCredentials: true }).query(params).post().json();
   return parseAuthSession(session);
};

export const refreshSessionWithCookie = async (refreshEndpoint: string): Promise<Session> => {
   const session = await authSessionRequest(refreshEndpoint, { includeCredentials: true }).post().json();
   return parseAuthSession(session);
};

export const logoutSessionWithCookie = (logoutEndpoint: string, accessToken: string): Promise<unknown> =>
   authSessionRequest(logoutEndpoint, { accessToken, includeCredentials: true }).post().json();

export const exchangeBootstrapCodeWithCookie = async (bootstrapEndpoint: string, code: string): Promise<Session> => {
   const session = await authSessionRequest(bootstrapEndpoint, { includeCredentials: true }).query({ code }).post().json();
   return parseAuthSession(session);
};

export const verifySmsLoginCodeWithCookie = async (verifyEndpoint: string, params: VerifySmsLoginParams): Promise<Session> => {
   const session = await authSessionRequest(verifyEndpoint, { includeCredentials: true }).query(params).post().json();
   return parseAuthSession(session);
};

export const createSameTabRefresh = () => {
   let inFlightRefresh: Promise<Session> | null = null;

   return (refreshRequest: () => Promise<Session>, onSession: (session: Session) => void): Promise<Session> => {
      if (inFlightRefresh !== null) {
         return inFlightRefresh;
      }

      inFlightRefresh = refreshRequest()
         .then((session) => {
            onSession(session);
            return session;
         })
         .finally(() => {
            inFlightRefresh = null;
         });

      return inFlightRefresh;
   };
};
